import { gql } from "@apollo/client";
import { CreateFeedCurve } from "./createFeedCurveCall";

// CTO todo copy in create
export const COPY_FEED_CURVE = gql`
  mutation CopyFeedCurve($domain: String!, $name: String!, $oldFeedCurveId: Int!) {
    feedCurve {
      copy(domain: $domain, name: $name, originalId: $oldFeedCurveId) {
        code
        success
        message
        updatedValues {
          feedcurve_id
          name
          feedLimit: feed_limit
          passFeed: pass_feed
          stimuli
        }
      }
    }
  }
`;

export interface CopyFeedCurveResponse {
  feedCurve: {
    copy: CreateFeedCurve;
  }
}
